import { render, staticRenderFns } from "./relatorios-hub.vue?vue&type=template&id=80ea8dce&scoped=true&"
import script from "./relatorios-hub.vue?vue&type=script&lang=js&"
export * from "./relatorios-hub.vue?vue&type=script&lang=js&"
import style0 from "./relatorios-hub.vue?vue&type=style&index=0&id=80ea8dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ea8dce",
  null
  
)

export default component.exports